import React, { useContext, useEffect, useState } from 'react';

import Request from '~/providers/Request';
import { historyPropType } from '~/config/routerPropTypes';
import PersonRecord from '~/records/PersonRecord';

import Context from '../context';
import Tabs from './Tabs';

function ShowPerson({ history }) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [record, setRecord] = useState(new PersonRecord());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (records && records[id]) {
      setRecord(record.updateAttributes(records[id]));
    }
    setLoading(true);
    Request.get(`/admin/users/${id}`, {})
      .then((response) => {
        setLoading(false);
        addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
        setRecord(record.updateAttributes(response.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  return (
    <Tabs
      idClient={id}
      loading={loading}
      record={record}
      setRecord={setRecord}
    />
  );
}

ShowPerson.propTypes = {
  history: historyPropType,
};

export default ShowPerson;
